// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"f43d228b","127":"d43234a8","262":"80687885","306":"c1bbd97b","603":"ad87463d","688":"306a26f4","713":"a2a1b585","755":"88c3db00"}[chunkId] + ".chunk.js";
};